module.exports = __webpack_public_path__ + "img/showcase-img1.7be78cc0.png";